
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LabelList } from 'recharts';
import {EuiFlexGrid, EuiFlexItem, EuiFormRow, EuiSpacer, EuiEmptyPrompt, EuiTable, EuiTableBody, EuiTableRowCell, EuiTableRow, EuiFlexGroup } from '@elastic/eui';
// import { toIntString } from '../../../../../../shared/utils/numbers';
import numeral from "numeral";
// import { EuiTableRowCell } from '@elastic/eui/src/components/table/table_row_cell';
import downArrow from './../../../../shared/Icons/down.png';
import upArrow from './../../../../shared/Icons/up.png';
import { toDecimalString } from '../../../../shared/utils/numbers';
import { useMemo } from 'react';

export const GraficoInforme = (props) =>{

    const {data, periodo, año, moneda, showMaskWater, showAnimation} = props;

    const toIntString = number => {
        var strFormat = "0,0";
        if(number < 0) strFormat = "(0,0)";
        return numeral(number).format(strFormat);
    };

    const getAporBDIData = (data) => {
        // console.log('getAporBDIData data', data)
        // for (let iAño = año - 4; iAño <= año; iAño++) {
        //     console.log('getAporBDIData año ', iAño);
        //     if(!data.some(item => item.año == iAño)){
        //         console.log('getAporBDIData año no ', iAño);
        //         data =[...data , {año: iAño}]
        //     }
        // }
        // console.log('getAporBDIData data', data)
        // return 
        var vArr = Object.values(data.reduce(function(groups, item) {
            var val = item["año"];
            if(val !== undefined && val.toString().length > 0){
                // if(groups[val]  === undefined)  groups[val] = {año: item.año, total: 0, internacional: 0,nacional: 0};
                groups[val] = groups[val] || {año: item.año, Aportacion: 0, BDI: 0, Apornacional: 0, Aporinternacional: 0, bdinacional: 0, bdiinternacional: 0, porc: 0, lbApor: false, lbBdi: false};
                groups[val].Aportacion += (item.idPais == '@@' ? item.apor : 0);
                groups[val].BDI += (item.idPais == '@@' ? item.bdi : 0);
                groups[val].porc += (item.idPais == '@@' ? item.porcapor : 0);
                groups[val].Apornacional += (item.idPais == '00' ? item.apor : 0);
                groups[val].Aporinternacional += (item.idPais == '99' ? item.apor : 0);
                groups[val].bdinacional += (item.idPais == '00' ? item.bdi : 0);
                groups[val].bdiinternacional += (item.idPais == '99' ? item.bdi : 0);
                groups[val].lbApor = item.labelBottom_apor || groups[val].lbApor;
                groups[val].lbBdi = item.labelBottom_bdi || groups[val].lbBdi;
            }
            return groups;
        }, []));

        // for (let iAño = año - 4; iAño <= año; iAño++) {
        //         console.log('getAporBDIData año ', iAño);
        //         if(!vArr.some(item => item.año == iAño)){
        //             console.log('getAporBDIData año no ', iAño);
        //             vArr =[...data , {año: iAño, Aportacion: null, BDI: null, Apornacional: null, Aporinternacional: null, bdinacional: null, bdiinternacional: null, porc: null, lbApor: false, lbBdi: false}]
        //         }
        //     }
        return vArr;
    }

    const getData = (data, prop) => {
        return Object.values(data.reduce(function(groups, item) {
            var val = item["año"];
            var vlb = item['labelBottom_' + prop];
            if(val !== undefined && val.toString().length > 0){
                groups[val] = groups[val] || {año: item.año, total: 0, internacional: 0,nacional: 0, porc: 0, lbtotal: false, lbinternacional: false, lbnacional: false };
                groups[val].total += (item.idPais == '@@' ? item[prop] : 0);
                groups[val].porc += (item.idPais == '@@' ? item['porc' + prop] : 0);
                groups[val].internacional += (item.idPais == '99' ? item[prop] : 0);
                groups[val].nacional += (item.idPais == '00' ? item[prop] : 0);
                groups[val].lbtotal += (item.idPais == '@@' ? vlb : false);
                groups[val].lbinternacional += (item.idPais == '99' ? vlb : false);
                groups[val].lbnacional += (item.idPais == '00' ? vlb : false);

            }
            return groups;
        }, []));
    }

    const getFormatTooltip = (values) =>{
        return toDecimalString(values,0)
    }

    const getGraficoTotIntNac = (pData, pTexto) =>{
        var bBottomTotal = Math.max.apply(Math, pData.map(function(o) { return o.lbtotal; })) > 0;
        var bBottomNac = Math.max.apply(Math, pData.map(function(o) { return o.lbnacional; })) > 0;
        var bBottomInt = Math.max.apply(Math, pData.map(function(o) { return o.lbinternacional; })) > 0;
        console.log('showAnimation ?? true', showAnimation ?? true);
        console.log('showAnimation', showAnimation);
        var respProps = {};
        if(!(showAnimation ?? true)){
            respProps={width:710, height: Math.round(window.innerHeight*0.35)-15}
        }
        return <div style={{ maxHeight: Math.round(window.innerHeight*0.35) + 'px', marginBottom: '120px'}}>
                <p style={{color: '#003f87',fontWeight: 'bold', marginTop: '15px', marginLeft: '15px'}}>{pTexto}</p>
                <ResponsiveContainer {...respProps}>
                <LineChart
                    width={600}
                    height={300}
                    data={pData}
                    margin={{
                        top: 40,
                        right: 40,
                        left: 40,
                        bottom: 10,
                    }} >
                    <CartesianGrid vertical={false} />
                    <XAxis dataKey="año" />
                    <XAxis dataKey="porc"  axisLine={false} tickLine={false} tick={renderXporcTick} interval={0} scale="auto" xAxisId="quarter" />
                    <YAxis hide={true} />
                    <Tooltip formatter={getFormatTooltip}/>
                    <Legend />
                    <Line type="linear" dataKey="total" stroke="#003f87" activeDot={{ r: 8 }} strokeWidth={4} dot={{  r: 2, strokeWidth: 4 }} isAnimationActive={showAnimation ?? true} >
                        <LabelList style={{fontSize:'12px'}} dataKey="total" position={bBottomTotal ? "bottom" : "top"} color="#003f87" offset={15} formatter={toIntString} fill="#003f87" fontWeight='bold'/>
                    </Line>
                    <Line type="linear" dataKey="nacional" stroke="#5b9ed5" activeDot={{ r: 8 }} strokeWidth={4} dot={{  r: 2, strokeWidth: 4 }} isAnimationActive={showAnimation ?? true}>
                        <LabelList style={{fontSize:'12px'}} dataKey="nacional" position={bBottomNac ? "bottom" : "top"} color="#5b9ed5" offset={15} formatter={toIntString} fill="#5b9ed5"  fontWeight='bold' />
                    </Line>
                    <Line type="linear" dataKey="internacional" stroke="#f47c00" activeDot={{ r: 8 }} strokeWidth={4} dot={{  r: 2, strokeWidth: 4 }} isAnimationActive={showAnimation ?? true}>
                        <LabelList style={{fontSize:'12px'}} dataKey="internacional" position={ bBottomInt ? "bottom" : "top"} color="#f47c00" offset={15} formatter={toIntString} fill="#f47c00"  fontWeight='bold'/>
                    </Line>         
                </LineChart>
                </ResponsiveContainer>
        </div>
    }

    const getGraficoAporBDI = (pData, pTexto) =>{
        var bBottomApor = Math.max.apply(Math, pData.map(function(o) { return o.lbApor; })) > 0;
        var bBottomBdi = Math.max.apply(Math, pData.map(function(o) { return o.lbBdi; })) > 0;
        var respProps = {};
        if(!(showAnimation ?? true)){
            respProps={width:710, height: Math.round(window.innerHeight*0.35)-15}
        }
        return <div style={{ maxHeight: Math.round(window.innerHeight*0.35) + 'px', marginBottom: '145px'}}>
        <p style={{color: '#003f87',fontWeight: 'bold', marginTop: '15px', marginLeft: '15px'}}>{pTexto}</p>
        <ResponsiveContainer {...respProps}>
        <LineChart
                    width={600}
                    height={300}
                    data={pData}
                    margin={{
                        top: 40,
                        right: 40,
                        left: 40,
                        bottom: 10,
                    }} >
                    <CartesianGrid vertical={false} />
                    <XAxis dataKey="año" />
                    <XAxis dataKey="porc"  axisLine={false} tickLine={false} tick={renderXporcTick} interval={0} scale="auto" xAxisId="quarter" />
                    <YAxis hide={true} />
                    <Tooltip formatter={getFormatTooltip}/>
                    <Legend />
                    <Line type="linear" dataKey="Aportacion" stroke="#003f87" activeDot={{ r: 8 }} strokeWidth={4} dot={{  r: 2, strokeWidth: 4 }} isAnimationActive={showAnimation ?? true} >
                        <LabelList style={{fontSize:'12px'}} dataKey="Aportacion" position={bBottomApor ? "bottom" : "top"} color="#003f87" offset={15} formatter={toIntString} fill="#003f87"  fontWeight='bold'/>
                    </Line>
                    <Line type="linear" dataKey="BDI" stroke="#f47c00" activeDot={{ r: 8 }} strokeWidth={4} dot={{  r: 2, strokeWidth: 4 }} isAnimationActive={showAnimation ?? true} >
                        <LabelList style={{fontSize:'12px'}} dataKey="BDI" position={bBottomBdi ? "bottom" : "top"} color="#f47c00" offset={15} formatter={toIntString} fill="#f47c00" fontWeight='bold'/>
                    </Line>         
                </LineChart>
                </ResponsiveContainer>
                <EuiTable id='Tabla-Informe' style={{ background: 'transparent'}} responsive>
                    <EuiTableBody>{renderRows(pData)}</EuiTableBody>
                </EuiTable>
        </div>
    }

    const renderRows=(pData)=> {
        return <>
                <EuiTableRow>
                    <EuiTableRowCell width={140} style={{paddingLeft:'15px', background: 'transparent'}} >APOR NAC</EuiTableRowCell>
                    {pData.length > 0 && <EuiTableRowCell align={'left'} style={{ background: 'transparent'}}>{toIntString(pData[0].Apornacional)}</EuiTableRowCell>}
                    {pData.length > 1 && <EuiTableRowCell align={'center'} style={{ background: 'transparent'}}>{toIntString(pData[1].Apornacional)}</EuiTableRowCell>}
                    {pData.length > 2 && <EuiTableRowCell align={'center'} style={{ background: 'transparent'}}>{toIntString(pData[2].Apornacional)}</EuiTableRowCell>}
                    {pData.length > 3 && <EuiTableRowCell align={'right'} style={{ background: 'transparent'}}>{toIntString(pData[3].Apornacional)}</EuiTableRowCell>}
                </EuiTableRow>
                <EuiTableRow>
                    <EuiTableRowCell width={140} style={{paddingLeft:'15px', background: 'transparent'}}>APOR INT</EuiTableRowCell>
                    {pData.length > 0 && <EuiTableRowCell align={'left'} style={{ background: 'transparent'}}>{toIntString(pData[0].Aporinternacional)}</EuiTableRowCell>}
                    {pData.length > 1 && <EuiTableRowCell align={'center'} style={{ background: 'transparent'}}>{toIntString(pData[1].Aporinternacional)}</EuiTableRowCell>}
                    {pData.length > 2 && <EuiTableRowCell align={'center'} style={{ background: 'transparent'}}>{toIntString(pData[2].Aporinternacional)}</EuiTableRowCell>}
                    {pData.length > 3 && <EuiTableRowCell align={'right'} style={{ background: 'transparent'}}>{toIntString(pData[3].Aporinternacional)}</EuiTableRowCell>}
                </EuiTableRow>
                <EuiTableRow>
                    <EuiTableRowCell width={140} style={{paddingLeft:'15px', background: 'transparent'}}>BDI NAC</EuiTableRowCell>
                    {pData.length > 0 && <EuiTableRowCell align={'left'} style={{ background: 'transparent'}}>{toIntString(pData[0].bdinacional)}</EuiTableRowCell>}
                    {pData.length > 1 && <EuiTableRowCell align={'center'} style={{ background: 'transparent'}}>{toIntString(pData[1].bdinacional)}</EuiTableRowCell>}
                    {pData.length > 2 && <EuiTableRowCell align={'center'} style={{ background: 'transparent'}}>{toIntString(pData[2].bdinacional)}</EuiTableRowCell>}
                    {pData.length > 3 && <EuiTableRowCell align={'right'} style={{ background: 'transparent'}}>{toIntString(pData[3].bdinacional)}</EuiTableRowCell>}
                </EuiTableRow>
                <EuiTableRow>
                    <EuiTableRowCell width={140} style={{paddingLeft:'15px', background: 'transparent'}}>BDI INT</EuiTableRowCell>
                    {pData.length > 0 && <EuiTableRowCell align={'left'} style={{ background: 'transparent'}}>{toIntString(pData[0].bdiinternacional)}</EuiTableRowCell>}
                    {pData.length > 1 && <EuiTableRowCell align={'center'} style={{ background: 'transparent'}}>{toIntString(pData[1].bdiinternacional)}</EuiTableRowCell>}
                    {pData.length > 2 && <EuiTableRowCell align={'center'} style={{ background: 'transparent'}}>{toIntString(pData[2].bdiinternacional)}</EuiTableRowCell>}
                    {pData.length > 3 && <EuiTableRowCell align={'right'} style={{ background: 'transparent'}}>{toIntString(pData[3].bdiinternacional)}</EuiTableRowCell>}
                </EuiTableRow>
            </>
    }

    const renderXporcTick = (tickProps) => {
        const { x, y, payload } = tickProps;
        const { value, offset } = payload;

        return <><image href={(value > 0 ? upArrow : downArrow)} x={x-40} y={y-15} height="15px" width="15px"/><text x={x} y={y} textAnchor="middle"><span dangerouslySetInnerHTML={{__html: '&nearr;'}} />{`${value} %`}</text></>;

    }

    const getNotData = () => {
        return <EuiEmptyPrompt
          iconType="inspect"
          title={<h2>No se han obtenido datos</h2>}
        />
      }

    const maskWater = useMemo(()=>{
        const show = showMaskWater===true ? true : false;
        return show ? 
        <h1 className='maskWaterGraphic'>{`BORRADOR`}</h1>
        :null
    },[showMaskWater])

      return(
        data && data.length>0 ?
        <>            
            <EuiFlexGrid columns={2} direction="row" style={{width:'98%',marginLeft: '10px'}} id='AreaImprimirPDF'>
                <EuiFlexGroup style={{width: '100%'}}>
                <EuiFlexItem>
                <div style={{margin: '9px', color: '#003f87', fontSize: 'small', padding: '15px', width: '100%'}}><span>  </span><span style={{float: 'right'}}>{`Miles de ${moneda}`}</span></div>
                </EuiFlexItem>
                </EuiFlexGroup>
                <EuiFlexGroup>
                        <EuiFlexItem  style={{position:'relative'}}>
                            {getGraficoTotIntNac(getData(data, 'cont'), 'CONTRATACIÓN (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' +  (periodo == 4 ? año +1 : año)  + '-Cierre)')}
                            {maskWater}
                        </EuiFlexItem>
                        <EuiFlexItem  style={{position:'relative'}}>
                            {getGraficoTotIntNac(getData(data, 'fact'), 'FACTURACIÓN (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' + (periodo == 4 ? año +1 : año) + '-Cierre)')}
                            {maskWater}
                        </EuiFlexItem>
                    </EuiFlexGroup>
                    <EuiFlexGroup>
                        <EuiFlexItem  style={{position:'relative'}}>
                            {getGraficoAporBDI(getAporBDIData(data), 'APORTACIÓN / BDI (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' + (periodo == 4 ? año +1 : año) + '-Cierre)')}
                            {maskWater}
                        </EuiFlexItem>
                        <EuiFlexItem  style={{position:'relative'}}>
                            {getGraficoTotIntNac(getData(data, 'prod'), 'PRODUCCIÓN (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' + (periodo == 4 ? año +1 : año) + '-Cierre)')}
                            {maskWater}
                        </EuiFlexItem>
                    </EuiFlexGroup>
            </EuiFlexGrid>
        </>
        :getNotData()
      )

    // return(
    //     data && data.length>0 ?
    //     <>            
    //         <EuiFlexGroup id='AreaImprimirPDF'>
    //             <EuiFlexItem>
    //                 <EuiSpacer size="m"/>
    //                 <EuiFormRow >
    //                     <EuiFlexGroup>
    //                         <EuiFlexItem width={8}>
    //                             {getGraficoTotIntNac(getContData(data), 'CONTRATACIÓN (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' + año + '-Cierre)')}
    //                         </EuiFlexItem>
    //                         <EuiFlexItem width={8}>
    //                             {getGraficoTotIntNac(getFactData(data), 'FACTURACIÓN (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' + año + '-Cierre)')}
    //                         </EuiFlexItem>
    //                     </EuiFlexGroup>
    //                 </EuiFormRow>
    //                 <EuiFormRow >
    //                     <EuiFlexGroup>
    //                         <EuiFlexItem width={8}>
    //                             {getGraficoAporBDI(getAporBDIData(data), 'APORTACIÓN / BDI (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' + año + '-Cierre)')}
    //                         </EuiFlexItem>
    //                         <EuiFlexItem width={8}>
    //                             {getGraficoTotIntNac(getProdData(data), 'PRODUCCIÓN (' + (periodo == 4 ? 'PROPUESTA DE ' : '') + 'OBJETIVOS ' + año + '-Cierre)')}
    //                         </EuiFlexItem>
    //                     </EuiFlexGroup>
    //                 </EuiFormRow>
    //             </EuiFlexItem>
    //         </EuiFlexGroup>
    //     </>
    //     :getNotData()
    //   )
}